import { useEffect, useState } from "react";
import { getSocket } from "../services/chartAgentSocket";

// Hook that returns the socket for the currently-selected AI backend
// version. When `aiVersion` changes (user flipped the dropdown), the
// effect re-runs and we hand back the socket for the new namespace.
//
// Each version has its own cached socket inside chartAgentSocket.js, so
// switching versions doesn't tear down the other side's connection.
export function useChartAgentSocket(aiVersion = "ai") {
  const [connected, setConnected] = useState(false);
  const [connectionError, setConnectionError] = useState(null);

  useEffect(() => {
    const socket = getSocket(aiVersion);

    setConnected(!!socket.connected);
    setConnectionError(null);

    const onConnect = () => {
      setConnected(true);
      setConnectionError(null);
    };
    const onDisconnect = () => setConnected(false);
    const onConnectError = (err) => {
      setConnected(false);
      setConnectionError({ code: err.data?.code || "connect_error", message: err.message });
    };

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("connect_error", onConnectError);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("connect_error", onConnectError);
    };
  }, [aiVersion]);

  return { socket: getSocket(aiVersion), connected, connectionError };
}
